import React from "react";

const AlignLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3.75 5.25V18.75C3.75 18.9489 3.67098 19.1397 3.53033 19.2803C3.38968 19.421 3.19891 19.5 3 19.5C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75V5.25C2.25 5.05109 2.32902 4.86032 2.46967 4.71967C2.61032 4.57902 2.80109 4.5 3 4.5C3.19891 4.5 3.38968 4.57902 3.53033 4.71967C3.67098 4.86032 3.75 5.05109 3.75 5.25ZM21 7.5H6.75C6.35218 7.5 5.97064 7.65804 5.68934 7.93934C5.40804 8.22064 5.25 8.60218 5.25 9V15C5.25 15.3978 5.40804 15.7794 5.68934 16.0607C5.97064 16.342 6.35218 16.5 6.75 16.5H21C21.3978 16.5 21.7794 16.342 22.0607 16.0607C22.342 15.7794 22.5 15.3978 22.5 15V9C22.5 8.60218 22.342 8.22064 22.0607 7.93934C21.7794 7.65804 21.3978 7.5 21 7.5Z"
      fill="currentColor"
    />
  </svg>
);

export default AlignLeft;
